import brand from '@helpers/brand';
import { fonts } from '@helpers/fonts';
import { from, Device } from '@helpers/media';
import styled, { css } from 'styled-components';
const Wrapper = styled.div `
  overflow-x: auto;
  padding-bottom: 10px;
  min-height: 300px;

  &::-webkit-scrollbar-track {
    background-color: ${brand.white};
    border-radius: 4px;
  }

  &::-webkit-scrollbar {
    height: 10px;
    width: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #d5d5d5;
    border: 1px solid ${brand.white};
    border-radius: 0;
    border-radius: 4px;
    cursor: pointer;
  }
`;
const Table = styled.div `
  min-width: 1280px;
`;
const Row = styled.div `
  display: grid;
  grid-gap: 22px;
  grid-template-columns: 130px 0.3fr 0.3fr 0.3fr 165px 1fr 0.5fr 0.5fr;
  align-items: center;
  padding: 8px 14px 4px;
  border-bottom: 1px solid ${brand.grey.grey89};

  @media ${from(Device.TabletLarge)} {
    grid-template-columns: 160px 0.3fr 0.3fr 0.3fr 165px 1fr 0.5fr 0.5fr;
  }

  &:last-child {
    border: none;
  }

  ${({ header }) => header &&
    css `
      border-color: ${brand.grey.grey35};

      ${() => Column} {
        ${fonts.DaxPro['Medium']};
      }
    `}
`;
const Column = styled.div `
  font-size: 16px;
  line-height: 1.2;
  ${fonts.DaxPro['Regular']};
  color: ${brand.black};
  display: flex;
  flex-direction: row;

  @media ${from(Device.Desktop)} {
    font-size: 18px;
  }

  a {
    color: ${brand.primary.base};
  }

  ${({ centerText }) => centerText &&
    css `
      text-align: center;
    `}
`;
const ExtendButton = styled.div `
  color: ${brand.grey.grey55};
  opacity: 0.5;
  padding-left: 14px;

  ${({ isLive }) => isLive &&
    css `
      color: ${brand.accent.orange};
      opacity: 1;

      svg {
        cursor: pointer;
      }
    `}

  svg {
    width: 20px;
    height: 23px;
  }
`;
const DownloadButton = styled.a `
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  &:hover small {
    text-decoration: underline;
  }

  small {
    font-size: 14px;
    ${fonts.DaxPro['Regular']};
    color: ${brand.grey.grey55};
  }

  img {
    width: 28px;
    height: 28px;
    margin-right: 10px;
  }
`;
const MinHeightPlaceholder = styled.div `
  min-height: 250px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  padding-top: 50px;
`;
const FixedInner = styled.div `
  position: sticky;
  width: 270px;
  left: 50%;
  transform: translateX(-50%);
`;
const NoResults = styled.p `
  font-size: 16px;
  color: ${brand.grey['grey20']};
  display: flex;
  align-items: center;
  justify-content: center;
  // This is to stop jumping when the loader shows dont @ me
  height: 90px;
`;
const TrackingLink = styled.a `
  color: ${brand.primary.base};

  svg {
    width: 30px;
    height: 25px;
  }
`;
const Indicator = styled.div `
  display: inline-block;
  position: relative;
  border: 1px solid ${brand.grey.grey20};
  border-radius: 50%;
  cursor: pointer;
  margin-left: 5px;
  width: 22px;
  height: 22px;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: ${brand.grey.grey20};
    width: 10px;
    height: 10px;
  }
`;
export default {
    Wrapper,
    Table,
    Row,
    Column,
    ExtendButton,
    DownloadButton,
    MinHeightPlaceholder,
    FixedInner,
    NoResults,
    TrackingLink,
    Indicator,
};
